import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { findCheckoutMapExtension, hasCheckoutMap } from '../integrationStatusUtils';
import { SettingsWrapper } from '../../settings-wrapper/SettingsWrapper';

export const CheckoutAppIntegration = ({
    extensions,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: CheckoutAppIntegrationProps) => {
    const { t } = useTranslation();

    const checkoutMapIntegration = useMemo(() => findCheckoutMapExtension(extensions), [extensions]);

    const hasCheckoutMapIntegration = useMemo(() => hasCheckoutMap(checkoutMapIntegration), [checkoutMapIntegration]);

    const handleAddStoreAppBlock = () => {
        open(`shopify://admin/settings/checkout/editor?page=checkout&context=apps`, '_blank');
        handleClickAddStoreAppBlock?.();
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.CHECKOUT_MAP_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasCheckoutMapIntegration ? 'success' : undefined}>
                    {hasCheckoutMapIntegration
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasCheckoutMapIntegration
                    ? t('DASHBOARD.APP_EXTENSIONS.CHECKOUT_MAP_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.CHECKOUT_MAP_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={handleAddStoreAppBlock}>
                    {t('DASHBOARD.APP_EXTENSIONS.CHECKOUT_MAP_INTEGRATION.ACTIONS.ADD_CHECKOUT_MAP')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface CheckoutAppIntegrationProps {
    extensions: ExtensionInfo[];
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
